import React, { Component } from 'react';
import '../../stylesheet/tabdesign.css'
import '../../stylesheet/cardsummary.css'
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import $ from 'jquery'
import * as actions from '../../actions/actions.jsx'
import { connect } from "react-redux";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CryptoJS from 'crypto-js'

// import AuthNavbar from '../navigation/authnavigation.jsx'
import AdminNavbar from '../navigation/adminnavigation.jsx'
const styles = {
    customWidth: {
        width: 150,
    },
    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },
    focusTextStyle: {
        color: "#333"
    },
    underlineStyle1: {
        borderTop: "none rgb(224, 224, 224)",
        borderLeft: "none rgb(224, 224, 224)",
        borderRight: "none rgb(224, 224, 224)",
        borderBottom: "1px solid rgb(224, 224, 224)",
        bottom: "22px",
        position: "relative",
        width: "100%"

    },
    buttonStyle: {
        background: "rgba(41, 40, 40, 0.87)",
    }
}

const mapStateToProps = state =>
    ({
        cardDetailState: state.getCardDetailsReducer.cardDetailState,
        useridInfoState: state.getUserIdInfoReducer.useridInfoState,
        mobileNoInfoState:state.getMobileNoInfoReducer.mobileNoInfoState
    })
const mapDispatchToProps = dispatch =>
    ({
        getCardDetails(cardRefNo) {
            dispatch(
                actions.getCardDetailAction(cardRefNo)
            )
        },
        getUserIdDetails(userId) {
            dispatch(
                actions.userIdInfoAction(userId)
            )
        },
        getMobileInfoDetails(mobileNo){
            dispatch(
                actions.mobileNoInfoAction(mobileNo)
            )
        }

    })



class CardSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOption: localStorage.getItem("tab") || "tab1",
            disabled: true,
            disabledUserSearch: true,
            disabledMobileSearch: true,
   
        }
    }
    handleChange(e) {
        this.setState({
            selectedOption: e.target.value
        })
    }
    componentDidMount(){
        if(this.props.cardDetailState.status === 401 || this.props.useridInfoState === 401 || this.props.mobileNoInfoState === 401 ){
            console.log("session out")
            localStorage.clear();
            this.props.history.push('/sessionout')
        }
    }
    cardNumber = (e, value) => {
        var regx = /^[0-9]{8,15}$/
        if (e.target.name === 'cardNumber' && e.target.value.length !== 0) {
            this.setState({
                cardNumber: e.target.value,
                disabled: false
            })
        }
        else {
            this.setState({
                disabled: true
            })
        }
    }
    userId = (e, value) => {
        if (e.target.name === "userId" && value.length !== 0) {

            this.setState({
                userName: value,
                disabledUserSearch: false
            })
        }
        else {
            this.setState({
                disabledUserSearch: true
            })
        }
    }

    mobileNo = (e, value) => {
        if (e.target.name === "mobileNo" && value.length !== 0) {

            this.setState({
                mobileNo: value,
                disabledMobileSearch: false
            })
        }
        else {
            this.setState({
                disabledMobileSearch: true
            })
        }

    }

    handleClick = () => {
        let _this = this
        localStorage.setItem('cardRefNumber', this.state.cardNumber)
        localStorage.setItem('cardSearchToast', 'first')
        this.props.getCardDetails(this.state.cardNumber)
        setTimeout(function(){
            if (localStorage.getItem('cardSearchToast') === 'second') {
                _this.props.history.push('/carddetails')
            }
        },3000)

    }

    handleUserId = () => {
        let _this = this
        var ciphertext = CryptoJS.AES.encrypt(this.state.userName, 'gmcabs123');
        localStorage.setItem('eu', ciphertext)
        this.props.getUserIdDetails(this.state.userName)
        localStorage.setItem('userIdToast', 'first')
        setTimeout(function(){
            if (localStorage.getItem('userIdToast') === 'second') {
                _this.props.history.push('/useriddetails')
            }
        },3000)
    }
    handleMobileNo = () => {
        let _this = this
        var ciphertext = CryptoJS.AES.encrypt(this.state.mobileNo, 'gmcabs123');
        localStorage.setItem('em', ciphertext)
        this.props.getMobileInfoDetails(this.state.mobileNo)
        localStorage.setItem('mobileNoToast', 'first')
        setTimeout(function(){
            if (localStorage.getItem('mobileNoToast') === 'second') {
                _this.props.history.push('/mobnodetails')
            }
        },3000)
    }

    render() {
        console.log(this.props.useridInfoState)
        const height = $(window).height() - 110;
        return (
            <div style={{ minHeight: height }}>
                <div className="col-sm-12">
                    <AdminNavbar />
                </div>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable
                    pauseOnHover
                />
                <div className="col-sm-12" style={{ marginTop: "100px" }}>
                    <span style={{ fontSize: "25px", fontWeight: "400" }}>
                        Card Search
                    </span>
                </div>
                <div className="col-sm-12" style={{ marginTop: "20px", padding: "0px 30px" }}>
                    <div className="row">
                        <div className="col-sm-4">
                            <div className="col-sm-12" style={{ boxShadow: "0px 1px 3px 2px rgba(0,0,0,0.2)" }}>
                                <div className="row">
                                    <div className="col-sm-12" style={{ background: "#eeeeee", minHeight: "40px", padding: "5px 0px 0px 10px" }}>
                                        <span className="offset-1" style={{ fontSize: "19px" }}>Search by Card Reference Number</span>
                                    </div>
                                    <div className="col-sm-12" style={{ padding: "0px" }}>
                                        <div className="row">
                                            <div className="col-sm-5" style={{ textAlign: "right", marginTop: "29px", marginLeft: "18px", padding: "0px" }}>
                                                Card Reference No:
                                </div>
                                            <div className="col-sm-6" style={{ marginTop: "-8px" }}>
                                                <TextField
                                                    hintText="Start Typing"
                                                    floatingLabelText="Reference Number"
                                                    type="number"
                                                    name="cardNumber"
                                                    className="input-width"
                                                    maxLength="15"
                                                    onInput={(e) => {
                                                        e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 15)
                                                    }}
                                                    onChange={this.cardNumber}
                                                    underlineFocusStyle={styles.focusStyle}
                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                // errorText={homeState ? correcthome ? null : "Not a valid phone number" : "This field is required"}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-8 offset-4" style={{ marginTop: "7px", marginBottom: "10px" }}>
                                        <RaisedButton
                                            label="Search"
                                            // buttonStyle={styles.buttonStyle}
                                            // labelColor="#fff"
                                            backgroundColor="#333"
                                            labelColor="#fff"
                                            onClick={this.handleClick}
                                            disabled={this.state.disabled}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-4">
                            <div className="col-sm-12" style={{ boxShadow: "0px 1px 3px 2px rgba(0,0,0,0.2)" }}>
                                <div className="row">
                                    <div className="col-sm-12" style={{ background: "#eeeeee", padding: "5px 0px 0px 80px", minHeight: "40px" }}>
                                        <span className="offset-1" style={{ fontSize: "19px" }}>Search by User ID</span>
                                    </div>
                                    <div className="col-sm-12" style={{ padding: "0px" }}>
                                        <div className="row">
                                            <div className="col-sm-5" style={{ textAlign: "right", marginTop: "25px", marginLeft: "18px" }}>
                                                Cardholder User ID:
                                </div>
                                            <div className="col-sm-6" style={{ marginTop: "-8px" }}>
                                                <TextField
                                                    hintText="Start Typing"
                                                    floatingLabelText="User ID"
                                                    type="text"
                                                    name="userId"
                                                    className="input-width"
                                                    maxLength="50"
                                                    onChange={this.userId}
                                                    underlineFocusStyle={styles.focusStyle}
                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                // errorText={homeState ? correcthome ? null : "Not a valid phone number" : "This field is required"}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-8 offset-4" style={{ marginTop: "7px", marginBottom: "10px" }}>
                                        <RaisedButton
                                            label="Search"
                                            // buttonStyle={styles.buttonStyle}
                                            // labelColor="#fff"
                                            backgroundColor="#333"
                                            labelColor="#fff"
                                            onClick={this.handleUserId}
                                            disabled={this.state.disabledUserSearch}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="col-sm-4" >
                            <div className="col-sm-12" style={{ boxShadow: "0px 1px 3px 2px rgba(0,0,0,0.2)" }}>
                                <div className="row">
                                    <div className="col-sm-12" style={{ background: "#eeeeee", padding: "5px 0px 0px 40px", minHeight: "40px" }}>
                                        <span className="offset-1" style={{ fontSize: "19px" }}>Search by Mobile Number</span>
                                    </div>
                                    <div className="col-sm-12" style={{ padding: "0px" }}>
                                        <div className="row">
                                            <div className="col-sm-5" style={{ textAlign: "right", marginTop: "29px", marginLeft: "18px", padding: "0px" }}>
                                                Cardholder Mobile No:
                                </div>
                                            <div className="col-sm-6" style={{ marginTop: "-8px" }}>
                                                <TextField
                                                    hintText="Start Typing"
                                                    floatingLabelText="Mobile Number"
                                                    type="text"
                                                    name="mobileNo"
                                                    className="input-width"
                                                    maxLength="10"
                                                    onChange={this.mobileNo}
                                                    underlineFocusStyle={styles.focusStyle}
                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                // errorText={homeState ? correcthome ? null : "Not a valid phone number" : "This field is required"}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-8 offset-4" style={{ marginTop: "7px", marginBottom: "10px" }}>
                                        <RaisedButton
                                            label="Search"
                                            // buttonStyle={styles.buttonStyle}
                                            // labelColor="#fff"
                                            backgroundColor="#333"
                                            labelColor="#fff"
                                            onClick={this.handleMobileNo.bind(this)}
                                            disabled={this.state.disabledMobileSearch}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>

            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CardSearch);


// WEBPACK FOOTER //
// ./src/components/adminuser/cardsearch.jsx